/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OtpType = {
  type: 'Enum',
} as const;
